import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef } from 'react';

export const ExportList = ({ parentEntity, parentEntityId }) => {
  const rsrc = useRsrc();
  const entityListRef = useRef();
  const module = useModuleFromRoute();

  const augRowsReq = useCallback((rowsReq) => {
    if (!parentEntity) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('entity', parentEntity, 'entityId', parentEntityId));
  }, [parentEntity, parentEntityId])

  const download = (data) => {
    rsrc.download(module, data.id);
  };

  const getContextMenuItems = (params) => {
    let contextMenus = entityListRef.current.getContextMenuItems(params);
    contextMenus.push(
      {
        name: 'Download',
        action: () => download(params.node.data),
        icon: fas.faArrowCircleDown
      }
    );
    return contextMenus;
  };


  return (
    <EntityList
      entity="EXPORT"
      augRowsReq={augRowsReq}
      ref={entityListRef}
      gridOptions={{ getContextMenuItems }}
    />
  )
}